const allCategory = [
  {
    _id: "669eb573158c56c6fcc34e71",
    name: "Bags",
    subCategory: [
      {
        _id: "669eb49d98a767283f8a4d69",
        name: "Backpacks",
      },
      {
        _id: "669eb49e98a767283f8a4d6e",
        name: "Bum Bags",
      },
      {
        _id: "669eb49e98a767283f8a4d72",
        name: "Cooler Bags",
      },
      {
        _id: "669eb4a098a767283f8a4d75",
        name: "Drawstring Bags",
      },
      {
        _id: "669eb4a198a767283f8a4d78",
        name: "Duffle/Sports Bags",
      },
      {
        _id: "669eb4a198a767283f8a4d7b",
        name: "Laptops",
      },
      {
        _id: "669eb4a398a767283f8a4d7e",
        name: "Luggage Tags",
      },
      {
        _id: "669eb4a498a767283f8a4d81",
        name: "Lunch Bags",
      },
      {
        _id: "669eb4a498a767283f8a4d84",
        name: "Paper Bags",
      },
      {
        _id: "669eb4a698a767283f8a4d87",
        name: "Satchels",
      },
      {
        _id: "669eb4a798a767283f8a4d8a",
        name: "Shoppers",
      },
      {
        _id: "669eb4a898a767283f8a4d8d",
        name: "Toiletry Bags",
      },
      {
        _id: "669eb4a998a767283f8a4d90",
        name: "Tote Bags",
      },
      {
        _id: "669eb4aa98a767283f8a4d93",
        name: "Travel Bags",
      },
      {
        _id: "669eb4ab98a767283f8a4d96",
        name: "Wallets & Purses",
      },
      {
        _id: "669eb4ac98a767283f8a4d99",
        name: "Wine Carriers",
      },
      {
        _id: "669eb4ad98a767283f8a4d9c",
        name: "Misc Bags",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e74",
    name: "Clothing",
    subCategory: [
      {
        _id: "669eb4ae98a767283f8a4d9f",
        name: "Accessories",
      },
      {
        _id: "669eb4af98a767283f8a4da2",
        name: "Aprons",
      },
      {
        _id: "669eb4b198a767283f8a4da5",
        name: "Dresses",
      },
      {
        _id: "669eb4b298a767283f8a4da8",
        name: "Footwear",
      },
      {
        _id: "669eb4b398a767283f8a4dab",
        name: "Gloves",
      },
      {
        _id: "669eb4b498a767283f8a4dae",
        name: "Hoodies",
      },
      {
        _id: "669eb4b598a767283f8a4db1",
        name: "Jackets",
      },
      {
        _id: "669eb4b698a767283f8a4db4",
        name: "Pants",
      },
      {
        _id: "669eb4b798a767283f8a4db7",
        name: "Polo Shirts",
      },
      {
        _id: "669eb4b898a767283f8a4dba",
        name: "Pullovers",
      },
      {
        _id: "669eb4b998a767283f8a4dbd",
        name: "Roughalls & Overalls",
      },
      {
        _id: "669eb4bb98a767283f8a4dc0",
        name: "Scarves",
      },
      {
        _id: "669eb4bc98a767283f8a4dc3",
        name: "Shirts",
      },
      {
        _id: "669eb4bd98a767283f8a4dc6",
        name: "Shorts",
      },
      {
        _id: "669eb4be98a767283f8a4dc9",
        name: "Singlets",
      },
      {
        _id: "669eb4bf98a767283f8a4dcc",
        name: "Skirts",
      },
      {
        _id: "669eb4c098a767283f8a4dcf",
        name: "Socks",
      },
      {
        _id: "669eb4c198a767283f8a4dd2",
        name: "T Shirts",
      },
      {
        _id: "669eb4c298a767283f8a4dd5",
        name: "Vests",
      },
      {
        _id: "669eb4c398a767283f8a4dd8",
        name: "Misc Clothing",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e76",
    name: "Drinkware",
    subCategory: [
      {
        _id: "669eb4c498a767283f8a4ddb",
        name: "Beer Glasses",
      },
      {
        _id: "669eb4c598a767283f8a4dde",
        name: "Cups & Tumblers",
      },
      {
        _id: "669eb4c698a767283f8a4de1",
        name: "Cups And Tumblers",
      },
      {
        _id: "669eb4c698a767283f8a4de4",
        name: "Drink Bottles",
      },
      {
        _id: "669eb4c898a767283f8a4de7",
        name: "Drinking Straws",
      },
      {
        _id: "669eb4c998a767283f8a4dea",
        name: "Flasks",
      },
      {
        _id: "669eb4c998a767283f8a4ded",
        name: "Glassware",
      },
      {
        _id: "669eb4ca98a767283f8a4df0",
        name: "Mugs",
      },
      {
        _id: "669eb4cc98a767283f8a4df3",
        name: "Reusable Coffee Cups",
      },
      {
        _id: "669eb4cd98a767283f8a4df6",
        name: "Sports Shakers",
      },
      {
        _id: "669eb4ce98a767283f8a4df9",
        name: "Stubby Holders",
      },
      {
        _id: "669eb4cf98a767283f8a4dfc",
        name: "Travel Mugs",
      },
      {
        _id: "669eb4d098a767283f8a4dff",
        name: "Wine Glasses",
      },
      {
        _id: "669eb4d198a767283f8a4e02",
        name: "Misc Drinkware",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e79",
    name: "Exhibitions & Events",
    subCategory: [
      {
        _id: "669eb4d298a767283f8a4e05",
        name: "Awards & Trophies",
      },
      {
        _id: "669eb4d398a767283f8a4e08",
        name: "Badge Holders",
      },
      {
        _id: "669eb4d498a767283f8a4e0b",
        name: "Banners",
      },
      {
        _id: "669eb4d698a767283f8a4e0e",
        name: "Flags & Bunting",
      },
      {
        _id: "669eb4d798a767283f8a4e11",
        name: "Fridge Magnets",
      },
      {
        _id: "669eb4d898a767283f8a4e14",
        name: "Gift Sets",
      },
      {
        _id: "669eb4d998a767283f8a4e17",
        name: "Lanyards",
      },
      {
        _id: "669eb4da98a767283f8a4e1a",
        name: "Name Badges",
      },
      {
        _id: "669eb4db98a767283f8a4e1d",
        name: "Table Covers",
      },
      {
        _id: "669eb4dc98a767283f8a4e20",
        name: "Wrist Bands",
      },
      {
        _id: "669eb4de98a767283f8a4e23",
        name: "Marquees",
      },
      {
        _id: "669eb4df98a767283f8a4e26",
        name: "Misc Events",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e7f",
    name: "Food & Drink",
    subCategory: [
      {
        _id: "669eb4df98a767283f8a4e29",
        name: "Bottled Water",
      },
      {
        _id: "669eb4e198a767283f8a4e2c",
        name: "Chocolates",
      },
      {
        _id: "669eb4e298a767283f8a4e2f",
        name: "Health Snacks",
      },
      {
        _id: "669eb4e298a767283f8a4e32",
        name: "Lollies",
      },
      {
        _id: "669eb4e498a767283f8a4e35",
        name: "Lollipops",
      },
      {
        _id: "669eb4e498a767283f8a4e38",
        name: "Mints",
      },
      {
        _id: "669eb4e698a767283f8a4e3b",
        name: "Cookies",
      },
      {
        _id: "669eb4e798a767283f8a4e3e",
        name: "Misc Food",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e85",
    name: "Fun & Games",
    subCategory: [
      {
        _id: "669eb4e798a767283f8a4e41",
        name: "Games",
      },
      {
        _id: "669eb4e898a767283f8a4e44",
        name: "Novelty Items",
      },
      {
        _id: "669eb4e998a767283f8a4e47",
        name: "Puzzles",
      },
      {
        _id: "669eb4ea98a767283f8a4e4a",
        name: "Soft Toys",
      },
      {
        _id: "669eb4eb98a767283f8a4e4d",
        name: "Stress Shapes",
      },
      {
        _id: "669eb4ec98a767283f8a4e50",
        name: "Toys",
      },
      {
        _id: "669eb4ed98a767283f8a4e53",
        name: "Misc Games",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e91",
    name: "Headwear",
    subCategory: [
      {
        _id: "669eb4ee98a767283f8a4e56",
        name: "Baseball Caps",
      },
      {
        _id: "669eb4ef98a767283f8a4e59",
        name: "Beanies",
      },
      {
        _id: "669eb4f098a767283f8a4e5c",
        name: "Bucket & Sun Hats",
      },
      {
        _id: "669eb4f198a767283f8a4e5f",
        name: "Flat Peak Caps",
      },
      {
        _id: "669eb4f298a767283f8a4e62",
        name: "Headbands",
      },
      {
        _id: "669eb4f398a767283f8a4e65",
        name: "Kid's Caps",
      },
      {
        _id: "669eb4f498a767283f8a4e68",
        name: "Straw Hats",
      },
      {
        _id: "669eb4f598a767283f8a4e6b",
        name: "Trucker Caps",
      },
      {
        _id: "669eb4f698a767283f8a4e6e",
        name: "Visors",
      },
      {
        _id: "669eb4f898a767283f8a4e71",
        name: "Misc Headwear",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e9a",
    name: "Health & Personal",
    subCategory: [
      {
        _id: "669eb4f998a767283f8a4e74",
        name: "Blankets",
      },
      {
        _id: "669eb4fa98a767283f8a4e77",
        name: "Brushes",
      },
      {
        _id: "669eb4fb98a767283f8a4e7a",
        name: "Eye Masks",
      },
      {
        _id: "669eb4fc98a767283f8a4e7d",
        name: "Face Masks",
      },
      {
        _id: "669eb4fd98a767283f8a4e80",
        name: "Fans",
      },
      {
        _id: "669eb4fe98a767283f8a4e83",
        name: "First Aid Kits",
      },
      {
        _id: "669eb4ff98a767283f8a4e86",
        name: "Hand Sanitisers",
      },
      {
        _id: "669eb4ff98a767283f8a4e89",
        name: "Head Massagers",
      },
      {
        _id: "669eb50098a767283f8a4e8c",
        name: "Heat Packs",
      },
      {
        _id: "669eb50198a767283f8a4e8f",
        name: "Lip Balms",
      },
      {
        _id: "669eb50298a767283f8a4e92",
        name: "Manicure Accessories",
      },
      {
        _id: "669eb50498a767283f8a4e95",
        name: "Manicure Sets",
      },
      {
        _id: "669eb50598a767283f8a4e98",
        name: "Mirrors",
      },
      {
        _id: "669eb50698a767283f8a4e9b",
        name: "Misc Health",
      },
      {
        _id: "669eb50798a767283f8a4e9e",
        name: "Pillows",
      },
      {
        _id: "669eb50898a767283f8a4ea1",
        name: "Safety Whistles",
      },
      {
        _id: "669eb50998a767283f8a4ea4",
        name: "Sunscreens",
      },
      {
        _id: "669eb50a98a767283f8a4ea7",
        name: "Towel Wipes",
      },
      {
        _id: "669eb50b98a767283f8a4eaa",
        name: "Towels",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34e9e",
    name: "Home & Living",
    subCategory: [
      {
        _id: "669eb50c98a767283f8a4ead",
        name: "Admats",
      },
      {
        _id: "669eb50d98a767283f8a4eb0",
        name: "Bottle Coolers",
      },
      {
        _id: "669eb50e98a767283f8a4eb3",
        name: "Cheese Boards",
      },
      {
        _id: "669eb50f98a767283f8a4eb6",
        name: "Clocks & Timers",
      },
      {
        _id: "669eb51098a767283f8a4eb9",
        name: "Coasters",
      },
      {
        _id: "669eb51198a767283f8a4ebc",
        name: "Coin Banks",
      },
      {
        _id: "669eb51298a767283f8a4ebf",
        name: "Corkscrews",
      },
      {
        _id: "669eb51398a767283f8a4ec2",
        name: "Kitchenware",
      },
      {
        _id: "669eb51498a767283f8a4ec5",
        name: "Misc Homeware",
      },
      {
        _id: "669eb51598a767283f8a4ec8",
        name: "Napkins",
      },
      {
        _id: "669eb51698a767283f8a4ecb",
        name: "Pet Accessories",
      },
      {
        _id: "669eb51798a767283f8a4ece",
        name: "Picture Frames",
      },
      {
        _id: "669eb51898a767283f8a4ed1",
        name: "Watches",
      },
      {
        _id: "669eb51998a767283f8a4ed4",
        name: "Wine Accessories",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34ea6",
    name: "Keyrings & Tools",
    subCategory: [
      {
        _id: "669eb51a98a767283f8a4ed7",
        name: "Auto Accessories",
      },
      {
        _id: "669eb51b98a767283f8a4eda",
        name: "Binoculars",
      },
      {
        _id: "669eb51b98a767283f8a4edd",
        name: "Bottle Openers",
      },
      {
        _id: "669eb51c98a767283f8a4ee0",
        name: "General Tools",
      },
      {
        _id: "669eb51d98a767283f8a4ee3",
        name: "Keyrings",
      },
      {
        _id: "669eb51e98a767283f8a4ee6",
        name: "Multi Tools",
      },
      {
        _id: "669eb51f98a767283f8a4ee9",
        name: "Tape Measures",
      },
      {
        _id: "669eb52098a767283f8a4eec",
        name: "Tool Sets",
      },
      {
        _id: "669eb52198a767283f8a4eef",
        name: "Torches",
      },
      {
        _id: "669eb52298a767283f8a4ef2",
        name: "Misc Tools",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34eab",
    name: "Leisure & Outdoors",
    subCategory: [
      {
        _id: "669eb52398a767283f8a4ef5",
        name: "BBQ Sets",
      },
      {
        _id: "669eb52498a767283f8a4ef8",
        name: "Chairs",
      },
      {
        _id: "669eb52598a767283f8a4efb",
        name: "Fitness Bands",
      },
      {
        _id: "669eb52698a767283f8a4efe",
        name: "Golf Accessories",
      },
      {
        _id: "669eb52798a767283f8a4f01",
        name: "Golf Balls",
      },
      {
        _id: "669eb52898a767283f8a4f04",
        name: "Jump Ropes",
      },
      {
        _id: "669eb52898a767283f8a4f07",
        name: "Pedometers",
      },
      {
        _id: "669eb52998a767283f8a4f0a",
        name: "Picnic Rugs",
      },
      {
        _id: "669eb52a98a767283f8a4f0d",
        name: "Picnic Sets",
      },
      {
        _id: "669eb52b98a767283f8a4f10",
        name: "Seedsticks",
      },
      {
        _id: "669eb52c98a767283f8a4f13",
        name: "Sports Balls",
      },
      {
        _id: "669eb52d98a767283f8a4f16",
        name: "Sports Gear",
      },
      {
        _id: "669eb52f98a767283f8a4f19",
        name: "Sunglasses",
      },
      {
        _id: "669eb53098a767283f8a4f1c",
        name: "Sunshades",
      },
      {
        _id: "669eb53198a767283f8a4f1f",
        name: "Sweat Bands",
      },
      {
        _id: "669eb53198a767283f8a4f22",
        name: "Tables",
      },
      {
        _id: "669eb53298a767283f8a4f25",
        name: "Umbrellas",
      },
      {
        _id: "669eb53398a767283f8a4f28",
        name: "Camp & Hike",
      },
      {
        _id: "669eb53498a767283f8a4f2b",
        name: "Misc Outdoors",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34eba",
    name: "Office Stationery",
    subCategory: [
      {
        _id: "669eb53598a767283f8a4f2e",
        name: "Business Card Holders",
      },
      {
        _id: "669eb53698a767283f8a4f31",
        name: "Calculators",
      },
      {
        _id: "669eb53798a767283f8a4f34",
        name: "Clips",
      },
      {
        _id: "669eb53898a767283f8a4f37",
        name: "Compendiums",
      },
      {
        _id: "669eb53998a767283f8a4f3a",
        name: "Desk Accessories",
      },
      {
        _id: "669eb53a98a767283f8a4f3d",
        name: "Desk Caddies",
      },
      {
        _id: "669eb53b98a767283f8a4f40",
        name: "Diaries",
      },
      {
        _id: "669eb53c98a767283f8a4f43",
        name: "Erasers",
      },
      {
        _id: "669eb53d98a767283f8a4f46",
        name: "Notebooks",
      },
      {
        _id: "669eb53d98a767283f8a4f49",
        name: "Notepads",
      },
      {
        _id: "669eb53e98a767283f8a4f4c",
        name: "Pencil Cases",
      },
      {
        _id: "669eb53f98a767283f8a4f4f",
        name: "Pencil Sharpeners",
      },
      {
        _id: "669eb54098a767283f8a4f52",
        name: "Portfolios",
      },
      {
        _id: "669eb54198a767283f8a4f55",
        name: "Rulers",
      },
      {
        _id: "669eb54298a767283f8a4f58",
        name: "Stickers",
      },
      {
        _id: "669eb54398a767283f8a4f5b",
        name: "Sticky Notes",
      },
      {
        _id: "669eb54498a767283f8a4f5e",
        name: "Misc Office",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34ec5",
    name: "Pens & Pencils",
    subCategory: [
      {
        _id: "669eb54598a767283f8a4f61",
        name: "Coloured Pencils",
      },
      {
        _id: "669eb54698a767283f8a4f64",
        name: "Eco Pens",
      },
      {
        _id: "669eb54798a767283f8a4f67",
        name: "Erasers",
      },
      {
        _id: "669eb54898a767283f8a4f6a",
        name: "Fountain Pens",
      },
      {
        _id: "669eb54998a767283f8a4f6d",
        name: "Highlighters",
      },
      {
        _id: "669eb54a98a767283f8a4f70",
        name: "Lead Pencils",
      },
      {
        _id: "669eb54b98a767283f8a4f73",
        name: "Metal Pens",
      },
      {
        _id: "669eb54c98a767283f8a4f76",
        name: "Novelty Pens",
      },
      {
        _id: "669eb54d98a767283f8a4f79",
        name: "Pen Packaging",
      },
      {
        _id: "669eb54e98a767283f8a4f7c",
        name: "Pencil Sharpeners",
      },
      {
        _id: "669eb54f98a767283f8a4f7f",
        name: "Plastic Pens",
      },
      {
        _id: "669eb55098a767283f8a4f82",
        name: "Stylus Pens",
      },
      {
        _id: "669eb55198a767283f8a4f85",
        name: "Misc Pens",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34ecb",
    name: "Print",
    subCategory: [
      {
        _id: "669eb55298a767283f8a4f88",
        name: "Ad Labels",
      },
      {
        _id: "669eb55398a767283f8a4f8b",
        name: "Business Cards",
      },
      {
        _id: "669eb55498a767283f8a4f8e",
        name: "Calendars",
      },
      {
        _id: "669eb55598a767283f8a4f91",
        name: "Combo Pads",
      },
      {
        _id: "669eb55698a767283f8a4f94",
        name: "Pads & Planners",
      },
      {
        _id: "669eb55798a767283f8a4f97",
        name: "Ribbons",
      },
      {
        _id: "669eb55998a767283f8a4f9a",
        name: "Stuk Notes",
      },
      {
        _id: "669eb55a98a767283f8a4f9d",
        name: "Misc Print",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34ed3",
    name: "USB & Tech",
    subCategory: [
      {
        _id: "669eb55b98a767283f8a4fa0",
        name: "Bluetooth Speakers",
      },
      {
        _id: "669eb55c98a767283f8a4fa3",
        name: "Cable Tidies",
      },
      {
        _id: "669eb55d98a767283f8a4fa6",
        name: "Car Chargers",
      },
      {
        _id: "669eb55e98a767283f8a4fa9",
        name: "Car Phone Mounts",
      },
      {
        _id: "669eb55f98a767283f8a4fac",
        name: "Charging Cables",
      },
      {
        _id: "669eb56098a767283f8a4faf",
        name: "Cleaning Cloths",
      },
      {
        _id: "669eb56198a767283f8a4fb2",
        name: "Earbuds",
      },
      {
        _id: "669eb56298a767283f8a4fb5",
        name: "Headphones",
      },
      {
        _id: "669eb56398a767283f8a4fb8",
        name: "Mouse Mats",
      },
      {
        _id: "669eb56498a767283f8a4fbb",
        name: "Phone Accessories",
      },
      {
        _id: "669eb56598a767283f8a4fbe",
        name: "Phone Stands",
      },
      {
        _id: "669eb56798a767283f8a4fc1",
        name: "Phone Wallets",
      },
      {
        _id: "669eb56798a767283f8a4fc4",
        name: "Pouches",
      },
      {
        _id: "669eb56898a767283f8a4fc7",
        name: "Powerbanks",
      },
      {
        _id: "669eb56998a767283f8a4fca",
        name: "Tablet Covers",
      },
      {
        _id: "669eb56a98a767283f8a4fcd",
        name: "Tech Accessories",
      },
      {
        _id: "669eb56b98a767283f8a4fd0",
        name: "Travel Adapters",
      },
      {
        _id: "669eb56c98a767283f8a4fd3",
        name: "USB Drives",
      },
      {
        _id: "669eb56d98a767283f8a4fd6",
        name: "USB Hubs",
      },
      {
        _id: "669eb56e98a767283f8a4fd9",
        name: "Wireless Chargers",
      },
      {
        _id: "669eb56f98a767283f8a4fdc",
        name: "Misc Tech",
      },
    ],
  },
  {
    _id: "669eb573158c56c6fcc34ed8",
    name: "Capital Equipment",
    subCategory: [
      {
        _id: "669eb57098a767283f8a4fdf",
        name: "Embroidery",
      },
      {
        _id: "669eb57098a767283f8a4fe2",
        name: "Laser",
      },
      {
        _id: "669eb57198a767283f8a4fe5",
        name: "Printers",
      },
      {
        _id: "669eb57298a767283f8a4fe8",
        name: "Other",
      },
    ],
  },
];

export default allCategory;
